import React from "react";

/**
 * Full-width restrained cinema-crop hero image with optional photo credit.
 */
export default function TopImage({
  src,
  alt,
  aspect = "aspect-[21/9]",
  overlay = false,
  credit,
  className = "",
  testId = "top-image",
}) {
  return (
    <div className={`container-narrow pt-8 sm:pt-12 ${className}`} data-testid={testId}>
      <figure className={`relative overflow-hidden rounded-lg ${aspect} bg-brand-paper animate-gentle-fade`}>
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover"
        />
        {overlay && (
          <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/25 via-transparent to-transparent" />
        )}
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0)_60%,rgba(26,37,64,0.10)_100%)]" />
      </figure>
      {credit && (
        <figcaption className="mt-2 text-[11.5px] text-brand-ink/45 tracking-wide" data-testid={`${testId}-credit`}>
          {credit}
        </figcaption>
      )}
    </div>
  );
}
